module.exports = __webpack_public_path__ + "static/media/HAUX_NUTRICAO_6.9a33214b.pdf";